import Vuex from 'vuex';
import Vue from 'vue';
import PhishingApi from './phishing-api';

Vue.use(Vuex)
export const store = new Vuex.Store({
  state:{
    cognitoInfo: {},
    loggedIn: false,
    loadingState: true,
    errorLoadingState: false,
    activeDomain: '',
    detailsDomain: '',
    phishingWebsites: [],
    phishingEmails: [],
    statsForDomain: null,
    statsForEmails: null,
    statsIntervalFilter: 'w'
  },
  mutations:{
    setLoggedIn(state, newValue){
      state.loggedIn = newValue
    },
    setLoggedOut(state){
      state.loggedIn = false;
      state.cognitoInfo = {};
    },
    setCognitoInfo(state, newValue){
      state.cognitoInfo = newValue;
    },
    setActiveDomain(state, newValue){
      state.activeDomain = newValue;
    },
    setPhishingWebsites(state, newValue){
      state.phishingWebsites = newValue
    },
    setPhishingEmails(state, newValue){
      state.phishingEmails = newValue
    },
    setStatsForDomain(state, newValue){
      state.statsForDomain = newValue
    },
    setStatsForEmails(state, newValue){
      state.statsForEmails = newValue
    },
    setStatsIntervalFilter(state, newValue){
      state.statsIntervalFilter = newValue
    },
    setDetailsDomain(state, newValue){
      state.detailsDomain = newValue
    }
  },
  getters:{
    loggedIn: function(state){
      return state.loggedIn
    },
    activeDomain: (state) => {
      return state.activeDomain
    },
    detailsDomain: (state) => {
      return state.detailsDomain
    },
    phishingWebsites: (state) => {
      return state.phishingWebsites
    },
    phishingEmails: (state) => {
      return state.phishingEmails
    },
    statsIntervalFilter: (state) => {
      return state.statsIntervalFilter
    }
  },
  actions:{
    refreshPhishingWebsites: function(state, context){
      PhishingApi.getPhishingWebsites(state.getters.activeDomain, state.getters.statsIntervalFilter)
      .then(response => state.commit('setPhishingWebsites', response))
    },
    refreshGraphs: function(state, context){
      PhishingApi.getStatisticsDomain(state.getters.activeDomain, state.getters.statsIntervalFilter)
      .then(response => state.commit('setStatsForDomain', response))
    },
    refreshEmailStatiEmailstics: function(state, context){
      PhishingApi.getStatisticsEmail(state.getters.statsIntervalFilter)
      .then(response => state.commit('setStatsForEmails', response))
    },
    refreshPhishingEmails: function(state, context){
      PhishingApi.getPhishingEmails(state.getters.statsIntervalFilter)
      .then(response => state.commit('setPhishingEmails', response))
    },
    generateExportReport: function(state, value){
      PhishingApi.generateReport(state.getters.activeDomain, state.getters.statsIntervalFilter, value)
        .then(response => response)
    },
    udpateDetailsDomain: function(state,context){
      PhishingApi.getDetailsWebsite(state.getters.detailsDomain)
      .then(response => response)
    }
  }
});

function checkRequiredForReport(){
  return (state.getters.activeDomain && state.getters.statsIntervalFilter) ? true : false
}